import { render, staticRenderFns } from "./ExpiredOffer.vue?vue&type=template&id=dd24107c&"
import script from "./ExpiredOffer.vue?vue&type=script&lang=js&"
export * from "./ExpiredOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports